import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

export default function BulkErrorDialog({ open, onOpenChange, result }) {
  if (!result) return null;
  const rejected = result.rejected;
  const errors = result.errors || [];
  const created = result.created || 0;
  const updated = result.updated || 0;
  const summary = [`${created} created`, `${updated} updated`].join(" · ");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto scrollbar-thin">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-full grid place-items-center ${rejected ? "bg-red-100 text-red-700" : "bg-emerald-100 text-emerald-700"}`}>
              {rejected ? <AlertTriangle className="w-5 h-5" /> : <CheckCircle2 className="w-5 h-5" />}
            </div>
            <div>
              <DialogTitle className="font-heading text-xl">
                {rejected ? "Upload rejected" : `Bulk upload complete — ${summary}`}
              </DialogTitle>
              <DialogDescription>
                {rejected
                  ? `${errors.length} row${errors.length === 1 ? "" : "s"} have errors — fix them and re-upload. Nothing was imported.`
                  : errors.length
                  ? `${errors.length} row${errors.length === 1 ? "" : "s"} could not be processed.`
                  : "All rows imported successfully."}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        {errors.length > 0 && (
          <div className="border border-border rounded-lg overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-muted/50 text-left text-[11px] uppercase tracking-widest text-muted-foreground">
                  <th className="px-4 py-2 w-20">Row</th>
                  <th className="px-4 py-2">Errors</th>
                </tr>
              </thead>
              <tbody>
                {errors.map((e, i) => (
                  <tr key={i} className="border-t border-border">
                    <td className="px-4 py-3 font-mono text-xs tabular-nums align-top">{e.row}</td>
                    <td className="px-4 py-3">
                      <ul className="list-disc pl-4 space-y-0.5 text-foreground/85">
                        {(e.errors || [e.error]).filter(Boolean).map((msg, j) => (
                          <li key={j}>{msg}</li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
